import React, { useState } from 'react';
import { X } from 'lucide-react';
import { getLiveProfile, setLiveProfile } from './device.jsx';
import { LiveSession } from './liveClient.jsx';
import { visitShare } from './sharesApi.jsx';
import { useAvatarManifest } from '../element3D/realAvatar.jsx';
import './livePicker.scss';

// قبل از «بازدیدِ مشترک»: اسم و آدمک (مرد/زن). یک بار انتخاب می‌شود و برای دفعه‌های بعد پیش‌فرض است.
// اتصال و صدا همین‌جا، در همان لمسِ دکمه، شروع می‌شوند (مرورگرها پخشِ صدا و میکروفون را فقط بعد از لمس می‌دهند).
// onStart(session)

function Silhouette({ female }) {
  return (
    <svg viewBox="0 0 64 96" width="56" height="84" aria-hidden="true">
      <circle cx="32" cy="14" r="10" fill="currentColor" />
      {female ? (
        <>
          <path d="M22 12c0-9 20-9 20 0v14c-3 2-17 2-20 0z" fill="currentColor" opacity="0.55" />
          <path d="M22 28h20l4 22H18z" fill="currentColor" />
          <path d="M18 50h28l8 22H10z" fill="currentColor" opacity="0.85" />
          <rect x="23" y="72" width="6" height="20" rx="3" fill="currentColor" />
          <rect x="35" y="72" width="6" height="20" rx="3" fill="currentColor" />
        </>
      ) : (
        <>
          <path d="M18 28h28l2 30H16z" fill="currentColor" />
          <rect x="19" y="56" width="11" height="36" rx="4" fill="currentColor" />
          <rect x="34" y="56" width="11" height="36" rx="4" fill="currentColor" />
        </>
      )}
    </svg>
  );
}

function LivePicker({ code, design, onStart, onClose }) {
  const saved = getLiveProfile();
  const [name, setName] = useState(saved ? saved.name : '');
  const [char, setChar] = useState(saved ? saved.char : null);
  // آدمک‌های واقعی (اگر روی سرور ساخته شده‌اند)؛ وگرنه مرد/زنِ ساده
  const avatars = useAvatarManifest();
  const real = avatars && avatars.length > 0;
  const chosen = real ? (avatars.some((a) => a.id === char) ? char : avatars[0].id) : char === 'f' ? 'f' : 'm';

  const start = () => {
    const clean = name.trim().slice(0, 24) || 'مهمان';
    setLiveProfile({ name: clean, char: chosen });
    const session = new LiveSession({ room: code, name: clean, char: chosen, design: design.id });
    session.start();
    visitShare(code, true);
    onStart(session, clean);
  };

  return (
    <div className="live-picker" onClick={onClose}>
      <div className="live-picker__card" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="live-picker__close" onClick={onClose} aria-label="بستن">
          <X size={18} strokeWidth={2} />
        </button>
        <h3>بازدیدِ مشترک</h3>
        <p className="live-picker__hint">
          هر کس از همین لینک وارد شود، داخلِ خانه همدیگر را می‌بینید و صدای هم را می‌شنوید (تا ۴ نفر). هر کس آزادانه
          خودش راه می‌رود.
        </p>
        <label className="live-picker__label" htmlFor="live-name">
          اسمِ شما
        </label>
        <input
          id="live-name"
          className="live-picker__input"
          value={name}
          maxLength={24}
          placeholder="مثلاً نگار"
          onChange={(e) => setName(e.target.value)}
        />
        <span className="live-picker__label">آدمکِ شما</span>
        {real ? (
          <div className="live-picker__avatars">
            {avatars.map((a) => (
              <button key={a.id} type="button" className={chosen === a.id ? 'is-on' : ''} onClick={() => setChar(a.id)}>
                <img src={a.thumbUrl} alt="" loading="lazy" />
              </button>
            ))}
          </div>
        ) : (
          <div className="live-picker__chars">
            <button type="button" className={chosen === 'm' ? 'is-on' : ''} onClick={() => setChar('m')}>
              <Silhouette />
              <span>مرد</span>
            </button>
            <button type="button" className={chosen === 'f' ? 'is-on' : ''} onClick={() => setChar('f')}>
              <Silhouette female />
              <span>زن</span>
            </button>
          </div>
        )}
        <button type="button" className="live-picker__go" onClick={start} disabled={avatars === null}>
          ورود به خانه
        </button>
        <p className="live-picker__mic">میکروفون مثلِ تماسِ تلفنی روشن است؛ داخلِ خانه دکمه‌ی قطع/وصل دارد.</p>
      </div>
    </div>
  );
}

export default LivePicker;
